module.exports = __webpack_public_path__ + "media/4.31a028e3.wav";